/**
 * Traduit le message d'erreur de la RPC `get_or_create_visio_room`
 * (`packages/db/migrations/0233_video_rooms.sql`) en texte élève/tuteur.
 * Mêmes codes que ceux gérés côté `visio-handoff-create` (statusForRoomError)
 * pour le chemin web — ici on ne route pas par HTTP status, juste le message.
 */
export function translateRoomError(message: string | null | undefined): string {
  if (!message) return 'Impossible de rejoindre la salle. Vérifie ta connexion et réessaie.';
  if (message.includes('reservation_not_found')) {
    return 'Ce rendez-vous est introuvable, ou a été annulé.';
  }
  if (message.includes('not_authorized')) {
    return "Tu n'as pas accès à ce rendez-vous.";
  }
  if (message.includes('reservation_not_confirmed')) {
    return "Ce rendez-vous n'est pas encore confirmé.";
  }
  if (message.includes('room_ended')) {
    return 'Ce rendez-vous est terminé : la réunion ne peut plus être rejointe.';
  }
  if (message.includes('outside_join_window')) {
    return 'La salle ouvre 10 minutes avant le début du rendez-vous.';
  }
  // Salle à plusieurs (migration 0256)
  if (message.includes('room_full')) {
    return 'La salle est pleine : le nombre maximum de participants est atteint.';
  }
  if (message.includes('room_locked')) {
    return "La salle est verrouillée par l'animateur : plus personne ne peut entrer.";
  }
  if (message.includes('removed_from_room')) {
    return "Tu as été retiré de cette salle par l'animateur.";
  }
  return 'Impossible de rejoindre la salle. Vérifie ta connexion et réessaie.';
}
